<template>
  <div class="about">
    <v-card width="400px">
      <!-- <v-card-subtitle>Zoom and double click..</v-card-subtitle> -->
      <v-row justify="center">
        <v-label>-- Zoom and Center --</v-label>
      </v-row>

      <div v-if="posInitiated">
        <SelectMapPosition
          v-bind="postposition"
          @pos_changed="selectedPosition"
        ></SelectMapPosition>
      </div>
    </v-card>
    <v-card>
      <!-- {{statusResult}} -->
      <v-alert dense v-if="statusResult === 1" type="success"
        >{{ statusResultMsg }}<v-spacer></v-spacer
        ><v-btn rounded small to="/airbox/0" color="primary">OK</v-btn></v-alert
      >
      <v-alert dense v-if="statusResult === 0" type="error"
        >{{ statusResultMsg }} .<v-btn
          small
          rounded
          to="/airbox/0"
          color="primary"
          >OK</v-btn
        ></v-alert
      >
    </v-card>
    <v-bottom-navigation color="primary" horizontal>
      <v-btn :disabled="!posSelected" elevation="12" @click="submit">
        <span>SAVE POSITION</span>
        <v-icon>mdi-map-marker-check-outline</v-icon>
      </v-btn>
      <v-dialog transition="dialog-bottom-transition" max-width="600">
        <template v-slot:activator="{ on, attrs }">
          <v-btn rounded v-bind="attrs" v-on="on"
            >Help<v-icon>mdi-information-outline</v-icon></v-btn
          >
        </template>
        <template v-slot:default="dialog">
          <div>
            <v-card>
              <v-toolbar color="primary" dark>
                <v-btn text @click="dialog.value = false"
                  >Close</v-btn
                ></v-toolbar
              >
              <!-- <v-card-text>
              <div class="text-h2 pa-12">Hello world!</div>
            </v-card-text> -->
              <AddPositionHelp></AddPositionHelp>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </template>
      </v-dialog>
      <v-btn to="/airbox/0">
        <span>Cancel</span>

        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import SelectMapPosition from "@/components/airbox/SelectMapPosition.vue";
import axios from "axios";
import AddPositionHelp from "@/components/help/AddPilotPositionHelp.vue";
// import { latLngBounds } from "leaflet";
// import { latLng } from "leaflet";

export default {
  data() {
    return {
      regId: Number,
      ac: String,
      postposition: {
        ilat: Number,
        ilng: Number,
        izoom: Number,
      },
      selectedLat: Number,
      selectedLng: Number,
      pilotpositions: [],
      errors: [],
      center: [59.504, 9.9969],
      eventId: Number,
      statusResult: Number,
      statusResultMsg: String,
      posSelected: Boolean,
      posInitiated: Boolean,
      isAlertVisible: Boolean,
      isWarningAlertVisible: Boolean,
      panel: [],
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.selectedLat = null;
    this.selectedLng = null;
    this.posSelected = false;
    this.posInitiated = false;
    this.eventid = this.$route.params.eventid;
    this.getCookies();
    this.getInitPositions();
  },
  methods: {
    selectedPosition(pos) {
      // console.log("selectedPosition",pos);
      this.selectedLat = pos.lat;
      this.selectedLng = pos.lng;
      this.posSelected = true;
    },
    setInitPosition() {
      this.postposition.ilat = this.center.lat;
      this.postposition.ilng = this.center.lng; //9.9072;
      if (this.postposition.ilat == null) {
        this.postposition.ilat = 59.5074;
        this.postposition.ilng = 9.9072;
      }

      this.postposition.izoom = 12;
      //   console.log("postposition", this.postposition);
      this.posInitiated = true;
    },
    submit() {
      var regId = this.pid;
      var ac = this.ac;
      var lat = this.selectedLat;
      var lon = this.selectedLng;
      var comment = this.comment;
      if (comment === null) {
        comment = "";
      }
      var toSubmit = JSON.stringify({ regId, ac, lat, lon, comment });
      const uri = this.baseUrl + "setpilotposition/" + regId;
      //   console.log("uri", uri);
      //   console.log("toSubmit:", toSubmit);
      this.sendpost(uri, toSubmit, 1);
    },
    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.pid = this.cookieRegId; //OBS: Bruker vanligvis regid her.
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
    getInitPositions() {
      var eventid = this.eventid;
      var regId = this.pid;
      var ac = this.ac;

      var toSubmit = JSON.stringify({ regId, ac });
      const uri = this.baseUrl + "getEventPilotPositions/" + eventid;
      console.log("uri", uri);
      console.log("toSubmit:", toSubmit);
      this.getEventPilotPositions(uri, toSubmit);
    },
    getEventPilotPositions(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.pilotpositions = response.data;
          this.center = {
            lat: this.pilotpositions[0].lat,
            lng: this.pilotpositions[0].lon,
          };
          console.log("pilotpositions", this.pilotpositions);
          this.setInitPosition();
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },
  },
  components: {
    SelectMapPosition,
    AddPositionHelp,
  },
};
</script>